/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

/*
 * list handler
 */
var $ = require('jquery');
var _ = require('underscore');
var operateService = require('../services/operate.service');
var utils = require('../services/util/common-utils');
var loading = require('../services/loading.service');
var handleServiceError = require('../services/handle-error.service');
var localize = require('../services/localize.service');
var translate = require('../services/translate.service');
var groupService = require('../services/group.service');
var getRegisteredAccountsHTML = require('../services/accounts.service');
var getPresetAccountsHTML = require('../services/presetAccount.service');
var networkServices = require('../services/networks.service');
var validateService = require('../services/validation.service');
var rootScope = require('../services/root-scope.service');
var networkEventManager = require('../services/network-event-manager.service');
var confirmDeletePopUpTemplate = require('../../templates').confirmDeletePopUpTemplate;
var presetHeader = require('../../templates').presetHeader;
var paymentApi = require('../services/payment-api.service');
var preloadSpecialButtons = require('../services/form.service').preloadSpecialButtons;
var getAvailableNetworksHTML = networkServices.getNetworksList;
var operateCallback = operateService.operateCallback;
const { RiskPlugin } = require('../../plugins/riskPlugin');

/**
 * Display a separator and networks title, if there are network, accounts and/or presetAccount
 * @param {object} presetAccount
 * @param {array} accounts list of accounts
 * @param {object} networks list of networks
 * @param {JQueryElement} listContainer the container of list of networks and accounts
 */
function addNetworksSeparator(presetAccount, accounts, networks, listContainer) {
    if ((_.isEmpty(accounts) && _.isEmpty(presetAccount)) || _.isEmpty(networks)) {
        return;
    }
    var title = translate('networks.other.title');
    listContainer.append('<div class="separator network-separator">');
    listContainer.append('<div class="no-style network-separator list">' + (title ? title : '') + '</div>');
}
/**
 * Display a separator and accounts title
 * @param {object} presetAccount
 * @param {array} accounts list of accounts
 * @param {object} networks list of networks
 * @param {JQueryElement} listContainer the container of list of networks and accounts
 */
function addAccountsSeparator(presetAccount, accounts, networks, listContainer) {
    if (_.isEmpty(accounts)) {
        return;
    }
    var title = translate('accounts.title');
    if (!_.isEmpty(presetAccount)) {
        listContainer.append('<div class="separator account-separator">');
    }
    listContainer.append('<div class="no-style account-separator list">' + (title ? title : '') + '</div>');
}

function addPresetSectionHeader(listContainer) {
    const title = translate('networks.preset.title');
    const description = translate('networks.preset.conditional.text');
    const presetAccount = rootScope.getPresetAccount();
    listContainer.prepend(presetHeader({ title, description, showText: networkServices.showPresetText(presetAccount) }));
}

/**
 * callback of listRequest
 * @param {object} err error object from ajax call
 * @param {object} listHandlerData the data from ajax call
 */
function listHandler(err, listHandlerData, visualErrorCallback) {
    //used in handleError in case of error before setProperties
    init(err, listHandlerData);

    function init(err, listHandlerData) {
        if (err) {
            return handleServiceError(err);
        }

        // configuring rootScope's glob storage
        RiskPlugin.configureExternalStorage(rootScope.storeData, rootScope.getStoredData, rootScope.removeStoredData);

        // initializing risk providers
        RiskPlugin.init(listHandlerData.riskProviders);

        // empty the listContainer to re-init it if it contains anything
        rootScope.getListContainer().html('');

        //set the configuration in the global variable
        rootScope.setProperties(listHandlerData);
        // request the translation, then setup the page
        getPageTranslation(listHandlerData, setupPage, listHandlerData);
    }
    function stopLiveValidation() {
        glob.validationShortTimer && glob.validationShortTimer.cancel && glob.validationShortTimer.cancel();
        glob.validationTimer && glob.validationTimer.cancel && glob.validationTimer.cancel();
    }

    /**
     * Gets a handler for standard submit button.
     */
    function bindSubmitButtonClick() {
        // if we are running for summary page
        $(document).on('click', '#' + rootScope.getPayButton(), function () {
            if (rootScope.isLiveValidation()) {
                stopLiveValidation();
            }
            if (glob.summaryPage) {
                var chargeLink = glob.presetAccount && glob.presetAccount.links.operation;
                if (chargeLink) {
                    loading.submitButtonInProgress();

                    // if merchant specific handler is defined summary page handler is defined
                    if (glob.summaryPageHandler) {
                        //at the first step execute an operation
                        glob.summaryPageHandler.doOperation(
                            {
                                url: chargeLink,
                                method: 'POST',
                                operationData: {
                                    providerRequests: RiskPlugin.getRiskData(),
                                },
                            },
                            (data) => {
                                operateCallback(null, data);
                            }
                        );
                    } else {
                        //in other case use standard operation function
                        paymentApi.operationRequest(
                            chargeLink,
                            {
                                providerRequests: RiskPlugin.getRiskData(),
                            },
                            operateCallback
                        );
                    }
                    loading.submitButtonNormal();
                } else {
                    throw new Error("Preset network/account doesn't contain operation link");
                }
            } else {
                loading.submitButtonInProgress();
                if (rootScope.getSelectedNetwork().networkCode === 'preset') {
                    if (rootScope.hasProceedFunction()) {
                        rootScope.proceedFunction(glob.listResponse);
                    } else {
                        if (glob.presetAccount && glob.presetAccount.redirect) {
                            utils.redirect(glob.presetAccount.redirect);
                        }
                    }
                } else {
                    validateService.validateForm();
                }
            }
        });
    }

    /**
     * Initializes the the submit button and it's loading icon.
     */
    function initSubmitButton() {
        loading.showPaymentLoading();
        loading.hidePaymentLoading();
        if (!_.contains(rootScope.getSubmitButtonBound(), rootScope.getPayButton())) {
            bindSubmitButtonClick();
            rootScope.setSubmitButtonBound();
        }
    }

    /**
     * Retrieves a property file on the server and creates a map that can be accessed within 'this' scope.
     *
     * @param data used to get the url
     * @param data The LIST data returned from the callback
     * @param the callback function
     */
    function getPageTranslation(data, callback, bindingData) {
        localize.load(data.links.lang, callback, bindingData);
    }

    function setupPage(err, translation) {
        if (err) {
            return handleServiceError(err);
        }
        var listContainer = rootScope.getListContainer();
        var showDelete = rootScope.showDelete();
        var presetAccount = rootScope.getPresetAccount();
        var accounts = rootScope.getAllAccounts();
        var networks = rootScope.getAllNetworks();
        var templateName = rootScope.getTemplateName();
        //save translation in global variable to be used in other components of the project
        rootScope.setPageTranslation(translation);
        //init the submit button
        initSubmitButton();

        //display the preset account
        listContainer.append(getPresetAccountsHTML(presetAccount, templateName));

        networks = rootScope.setAllNetworks(groupService.group(networks));

        // check if there is a single choice of method
        rootScope.setIsSingleMethod(accounts.length + _.size(networks) === 1);

        // create grouped list of networks by groupTypes and save in global variable
        if (!glob.summaryPage) {
            //display a header for preset section to describe it
            if (!_.isEmpty(presetAccount)) {
                addPresetSectionHeader(listContainer);
            }

            //display separator between accounts and networks
            addAccountsSeparator(presetAccount, accounts, networks, listContainer);

            //display the list of registered accounts
            listContainer.append(getRegisteredAccountsHTML(accounts, showDelete, templateName));
            listContainer.append(confirmDeletePopUpTemplate(null, templateName));
            translateDeleteButtons();

            //display separator between accounts and networks
            addNetworksSeparator(presetAccount, accounts, networks, listContainer);
        }

        if (!glob.summaryPage) {
            //display list of networks
            listContainer.append(getAvailableNetworksHTML(networks, rootScope.isSmartSwitch(), templateName));
        }

        //bind click event on networks and accounts
        bindEvents();
        //auto select network and translate button label depending on that

        networkServices.preCheckSelectedNetwork();

        //show the global visual error after loading the container if exists
        //mainly used in RELOAD and TRY_OTHER_NETWORK
        visualErrorCallback && visualErrorCallback();

        //preload special buttons if not the current selected option
        if (!glob.summaryPage) {
            rootScope.resetRemainingProcess();
            preloadSpecialButtons();
        } else {
            //hide the loading after setup page
            loading.hideFullPageLoading();
        }
    }

    function bindEvents() {
        //check if events are bound for example in RELOAD to not bind again

        if (rootScope.isEventBound()) {
            return;
        }
        networkEventManager.bindAccountClick();
        networkEventManager.bindDeleteClick();
        networkEventManager.bindNetworkClick();
        networkEventManager.bindPresetAccountClick();
        networkEventManager.bindAccountSelection();
        if (rootScope.isLiveValidation()) {
            validateService.addLiveValidation();
        }

        rootScope.setEventBound(true);
    }

    function translateDeleteButtons() {
        $('#submit-delete').html(translate('button.delete.label'));
        $('#cancel-delete').html(translate('button.cancel.label'));
        $('.delete-account span').html(translate('button.delete.label'));
        $('.delete-account-submit').html(translate('button.delete.label'));
    }
}

module.exports = listHandler;
